<nav>
  <div class="nav-links">
    <img src="assets/img/auri_logo.png" alt="Auri" height="60">
    <a routerLink="/cliente/inicio">Inicio</a>
  </div>

  <div class="nav-actions">
    <a class="active">{{ nombrePerfil }}</a>
    <button class="btn btn-custom nav-arrow" type="button" (click)="logout()">Cerrar sesion</button>
  </div>
</nav>

<ng-template #imageModal>
  <div class="modal-header bg-dark">
    <h5 class="text-white mb-0">{{ selectedImage?.title }}</h5>
    <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
  </div>
  <div class="modal-body image-modal-body">
    <div class="modal-carousel">
      <button
        class="carousel-arrow carousel-arrow-prev"
        type="button"
        *ngIf="selectedImage?.images?.length > 1"
        (click)="previousModalImage()">
        <img src="assets/img/arrow  next.png" alt="Anterior">
      </button>
      <img [src]="modalImageSrc" [alt]="selectedImage?.title">
      <button
        class="carousel-arrow"
        type="button"
        *ngIf="selectedImage?.images?.length > 1"
        (click)="nextModalImage()">
        <img src="assets/img/arrow  next.png" alt="Siguiente">
      </button>
    </div>
    <p class="mb-0 mt-3">{{ selectedImage?.caption }}</p>
  </div>
</ng-template>

<div class="bg-yellow">
  <div class="libreta">
    <div class="warning-message mb-4" *ngIf="loadingInitial">
      Cargando datos del cliente...
    </div>
    <div class="warning-message mb-4" *ngIf="errorMessage">
      <img src="assets/img/warning-logo.png" alt="">
      {{ errorMessage }}
    </div>

    <header class="process-header">
      <p class="lead mb-0 mt-0">{{ currentStep.helper }}</p>
    </header>

    <div class="steps">
      <button
        class="step"
        type="button"
        *ngFor="let step of steps; let i = index"
        [ngClass]="{ active: activeStepIndex === i, done: activeStepIndex > i }"
        (click)="selectStep(i)">
        <span class="circle">{{ i + 1 }}</span>
        <span>{{ step.label }}</span>
      </button>
    </div>

    <section class="screen" *ngIf="activeStepIndex === 0">
      <div class="screen-title">
        <div>
          <p class="eyebrow">Paso 1</p>
          <h2>Escoger familia asignada</h2>
        </div>
        <span class="status-label">Grupo: 6A Universidad Auri</span>
      </div>

      <div class="package-grid" *ngIf="families.length; else noFamilies">
        <article
          class="package-card"
          *ngFor="let familia of families"
          [ngClass]="{ selected: selectedFamilyId === familia.id }">
          <button class="image-button" type="button" (click)="openGallery(imageModal, [familia.imagen], familia.nombre, familia.descripcion)">
            <img [src]="familia.imagen" [alt]="familia.nombre">
          </button>
          <div class="package-body family-body">
            <h3>{{ familia.nombre }}</h3>
            <p>{{ familia.descripcion }}</p>
            <button class="btn action-btn" type="button" (click)="selectFamily(familia)">
              Ver paquetes
              <img src="assets/img/arrow  next.png" alt="">
            </button>
          </div>
        </article>
      </div>
      <ng-template #noFamilies>
        <div class="warning-message">
          <img src="assets/img/warning-logo.png" alt="">
          No hay familias activas para tu grupo.
        </div>
      </ng-template>
    </section>

    <section class="screen" *ngIf="activeStepIndex === 1">
      <div class="screen-title">
        <div>
          <p class="eyebrow">Paso 2</p>
          <h2>Escoger paquete</h2>
        </div>
        <span class="status-label">Familia: {{ selectedFamily.nombre }}</span>
      </div>

      <div class="warning-message mb-4" *ngIf="loadingPackages">
        Cargando paquetes...
      </div>
      <div class="package-grid" *ngIf="familyPackages.length; else noPackages">
        <article
          class="package-card"
          *ngFor="let paquete of familyPackages"
          [ngClass]="{ selected: selectedPackageId === paquete.id }">
          <button class="image-button" type="button" (click)="openGallery(imageModal, [paquete.imagen], paquete.nombre, paquete.descripcion)">
            <img [src]="paquete.imagen" [alt]="paquete.nombre">
          </button>
          <div class="package-body">
            <h3>{{ paquete.nombre }}</h3>
            <p>{{ paquete.descripcion }}</p>
            <strong>{{ paquete.precio | currency:'MXN':'symbol':'1.0-0' }}</strong>
            <ul>
              <li *ngFor="let item of paquete.incluye">{{ item }}</li>
            </ul>
            <button class="btn action-btn" type="button" (click)="selectPackage(paquete)" [disabled]="savingPackage">
              {{ savingPackage && selectedPackageId === paquete.id ? 'Guardando...' : 'Elegir paquete' }}
              <img src="assets/img/arrow  next.png" alt="">
            </button>
          </div>
        </article>
      </div>
      <ng-template #noPackages>
        <div class="warning-message">
          <img src="assets/img/warning-logo.png" alt="">
          No hay paquetes activos en esta familia.
        </div>
      </ng-template>
    </section>

    <section class="screen" *ngIf="activeStepIndex === 2">
      <ng-container *ngIf="!activeProduct; else productOptions">
        <div class="screen-title">
          <div>
            <p class="eyebrow">Paso 3</p>
            <h2>
              Productos del paquete: 
              <small *ngFor="let product of currentProducts; let i = index; let isLast = last">
                {{ product.nombre }}{{ isLast ? '' : ', ' }}
              </small>
            </h2>
          </div>
          <span class="status-label">{{ completedProductCount }} de {{ currentProducts.length }} configurados</span>
        </div>

        <div class="product-grid">
          <article class="product-card" *ngFor="let product of currentProducts">
            <div class="product-main">
              <button class="product-thumb" type="button" (click)="openGallery(imageModal, [product.imagen], product.nombre, product.descripcion)">
                <img [src]="product.imagen" [alt]="product.nombre">
              </button>
              <div>
                <h3>{{ product.nombre }}</h3>
                <p>{{ product.descripcion }}</p>
                <p class="selected-choice" *ngIf="getSelectedVariation(product); else pendingChoice">
                  {{ getSelectedVariation(product)?.nombre }}
                </p>
                <ng-template #pendingChoice>
                  <p class="pending-choice">{{ product.variaciones.length ? 'Falta escoger variacion' : 'Sin opciones por escoger' }}</p>
                </ng-template>
              </div>
            </div>
            <div class="product-state">
              <img [src]="isProductComplete(product) ? 'assets/img/good.png' : 'assets/img/pending.png'" [alt]="isProductComplete(product) ? 'Listo' : 'Pendiente'">
              <button class="btn btn-custom activeBtn" type="button" (click)="openProduct(product)" [disabled]="!product.variaciones.length">
                {{ product.variaciones.length ? 'Escoger' : 'Listo' }}
              </button>
            </div>
          </article>
        </div>
      </ng-container>

      <ng-template #productOptions>
        <div class="screen-title">
          <div>
            <p class="eyebrow">Producto</p>
            <h2>{{ activeProduct?.nombre }}</h2>
          </div>
          <button class="btn btn-custom footer-prev" type="button" (click)="backToProductList()">
            <img src="assets/img/arrow  next.png" alt="">
            Lista de productos
          </button>
        </div>

        <div class="variation-grid">
          <article
            class="variation-card"
            *ngFor="let variation of activeProduct?.variaciones"
            [ngClass]="{ selected: activeProduct?.selectedVariationId === variation.id }">
            <div class="variation-image">
              <button
                class="carousel-arrow carousel-arrow-prev"
                type="button"
                *ngIf="variation.imagenes.length > 1"
                (click)="previousVariationImage(variation, $event)">
                <img src="assets/img/arrow  next.png" alt="Anterior">
              </button>
              <button
                class="image-button"
                type="button"
                (click)="openGallery(imageModal, variation.imagenes, variation.nombre, variation.descripcion, getVariationImageIndex(variation))">
                <img [src]="getVariationImage(variation)" [alt]="variation.nombre">
              </button>
              <button
                class="carousel-arrow"
                type="button"
                *ngIf="variation.imagenes.length > 1"
                (click)="nextVariationImage(variation, $event)">
                <img src="assets/img/arrow  next.png" alt="Siguiente">
              </button>
            </div>
            <div class="variation-body">
              <h3>{{ variation.nombre }}</h3>
              <p>{{ variation.descripcion }}</p>
              <button class="btn action-btn" type="button" (click)="selectActiveVariation(variation)" [disabled]="savingVariation">
                {{ savingVariation ? 'Guardando...' : 'Elegir opcion' }}
                <img src="assets/img/arrow  next.png" alt="">
              </button>
            </div>
          </article>
        </div>
      </ng-template>
    </section>

    <section class="screen" *ngIf="activeStepIndex === 3">
      <div class="screen-title">
        <div>
          <p class="eyebrow">Paso 4</p>
          <h2>Desglose antes de pagar</h2>
        </div>
        <span class="status-label">Total: {{ paymentTotal | currency:'MXN':'symbol':'1.0-0' }}</span>
      </div>

      <div class="summary-layout">
        <div class="summary-list">
          <div class="summary-row">
            <span>{{ selectedPackage.nombre }}</span>
            <strong>{{ selectedPackage.precio | currency:'MXN':'symbol':'1.0-0' }}</strong>
          </div>
          <div class="summary-row" *ngFor="let extra of extras">
            <span>
              {{ extra.label }}
              <small>{{ extra.detail }}</small>
            </span>
            <strong>{{ extra.amount | currency:'MXN':'symbol':'1.0-0' }}</strong>
          </div>
          <div class="summary-total">
            <span>Total a pagar</span>
            <strong>{{ paymentTotal | currency:'MXN':'symbol':'1.0-0' }}</strong>
          </div>
        </div>

        <div class="selection-preview">
          <h3>Seleccion del usuario</h3>
          <button class="preview-thumb" type="button" (click)="openGallery(imageModal, [selectedPackage.imagen], selectedPackage.nombre, selectedPackage.descripcion)">
            <img [src]="selectedPackage.imagen" [alt]="selectedPackage.nombre">
          </button>
          <div class="mini-list">
            <p *ngFor="let product of currentProducts">
              <strong>{{ product.nombre }}:</strong>
              {{ getSelectedVariation(product)?.nombre || 'Pendiente' }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="screen" *ngIf="activeStepIndex === 4">
      <div class="screen-title">
        <div>
          <p class="eyebrow">Paso 5</p>
          <h2>Pantalla de pagar</h2>
        </div>
        <span class="status-label">Pedido listo</span>
      </div>

      <div class="payment-layout">
        <div class="payment-panel">
          <h3>Modulo de pago</h3>
          <p>Tu pedido esta listo para pagar con tarjeta o referencia en efectivo.</p>
          <div class="total-ticket mb-3">
            <p>Total</p>
            <strong>{{ paymentTotal | currency:'MXN':'symbol':'1.0-0' }}</strong>
            <small>{{ selectedPackage.nombre }}</small>
          </div>
          <button class="btn pay-btn" type="button" (click)="goToPayment()">
            Continuar a pago
            <img src="assets/img/arrow  next.png" alt="">
          </button>
        </div>

        <div class="payment-side">
          <div class="total-ticket">
            <p>Total</p>
            <strong>{{ paymentTotal | currency:'MXN':'symbol':'1.0-0' }}</strong>
            <small>{{ selectedPackage.nombre }}</small>
          </div>
          <div class="payment-logos">
            <img src="assets/img/visa.png" alt="Visa">
            <img src="assets/img/masterCard.png" alt="Mastercard">
            <img src="assets/img/oxxopay_brand.png" alt="Oxxo Pay">
          </div>
          <div class="warning-message">
            <img src="assets/img/warning-logo.png" alt="">
            Revisar datos antes de confirmar evita cambios despues del pedido.
          </div>
        </div>
      </div>
    </section>

    <div class="footer-actions">
      <button class="btn btn-custom footer-prev" type="button" (click)="previousStep()" [disabled]="activeStepIndex === 0">
        <img src="assets/img/arrow  next.png" alt="">
        Anterior
      </button>
      <button class="btn action-btn" type="button" (click)="nextStep()" [disabled]="activeStepIndex === steps.length - 1">
        Siguiente
        <img src="assets/img/arrow  next.png" alt="">
      </button>
    </div>
  </div>
</div>
